import styled from 'styled-components';

export const ColaboradoresScroll = styled.div`
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #eee;
  padding-top: 10px;
  border-radius: 3px;

  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 99px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
